import { C as Cart } from './cart-DZS7CGyq.js';
import { P as PubSub } from './pubsub-COBwjfLh.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';
import './uniq-BDEfcc0N.js';
import './notyf-DIw0RvBj.js';

class LinkIconCart extends HTMLElement {
  #unsubscribers = [];

  static {
    Cart.sections.push('fetch-link-icon-cart');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        PubSub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Add cart count
   */
  #renderSection(sections) {
    const sectionHtml = sections?.['fetch-link-icon-cart'];
    if (!sectionHtml) return;

    const html = parseHTML(sectionHtml);
    const target = html.querySelector('link-icon-cart');
    if (target) this.replaceWith(target);
  }
}

customElements.define('link-icon-cart', LinkIconCart);
